/* ==========================================================================
   AMARA · carrito
   Cantidad, quitar y añadir sin recargar. Habla con /cart/change.js y
   /cart/add.js y repinta las secciones que estén en la página: el drawer,
   la plantilla /cart y el contador de la cabecera.

   Todo lo que hay aquí es mejora progresiva. Sin JS los controles siguen
   siendo formularios que envían a /cart y la página se recarga.
   ========================================================================== */

(function () {
  /* Cerrojo de una sola vez.

     Este archivo cuelga sus escuchadores de `document`, así que cargarlo
     dos veces no duplica el script: duplica cada acción. Estuvo incluido a
     la vez en el drawer y en la sección del carrito y cada «Añadir» en
     /cart metía dos envases. Ya está arreglado en el layout, pero el
     cerrojo hace que volver a incluirlo sea inofensivo en vez de caro. */
  if (window.__amCartBound) return;
  window.__amCartBound = true;

  'use strict';

  var ROOT = document.documentElement;
  var pending = 0;

  // En tiendas con prefijo de idioma la raíz no es '/'. Shopify la inyecta,
  // pero si faltara nos quedamos con la raíz simple antes que romper.
  function base() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* --- qué secciones hay que repintar ------------------------------------ */

  function targets() {
    var list = [];
    if (document.getElementById('CartDrawer')) {
      list.push({ id: 'cart-drawer', into: '#CartDrawer', from: '#CartDrawer' });
    }
    if (document.getElementById('cart-icon-bubble')) {
      list.push({ id: 'cart-icon-bubble', into: '#cart-icon-bubble', from: '.shopify-section' });
    }
    var page = document.querySelector('[data-am-cart-section]');
    if (page) {
      var id = page.getAttribute('data-am-cart-section');
      list.push({ id: id, into: '[data-am-cart-section]', from: '[data-am-cart-section]' });
    }
    return list;
  }

  function busy(on) {
    pending += on ? 1 : -1;
    if (pending < 0) pending = 0;
    var scope = document.querySelector('.am-cartd__body') || document.querySelector('.am-cartpage__body');
    if (scope) scope.classList.toggle('am-cart-busy', pending > 0);
    ROOT.classList.toggle('am-cart-loading', pending > 0);
  }

  /* --- repintado --------------------------------------------------------- */

  function paint(state, list) {
    if (!state || !state.sections) return;
    var parser = new DOMParser();

    list.forEach(function (t) {
      var html = state.sections[t.id];
      if (!html) return;
      var host = document.querySelector(t.into);
      if (!host) return;
      var parsed = parser.parseFromString(html, 'text/html').querySelector(t.from);
      if (!parsed) return;
      host.innerHTML = parsed.innerHTML;
      // Repintar de golpe se nota como un salto. Un asentado corto sobre la
      // zona que cambió lo convierte en un cambio de estado, no en un parpadeo.
      host.classList.remove('am-settled');
      void host.offsetWidth;
      host.classList.add('am-settled');
    });

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.toggle('is-empty', state.item_count === 0);
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
    }

    document.dispatchEvent(new CustomEvent('amara:cart:updated', { detail: { cart: state } }));
  }

  function fail(line, message) {
    var box = document.querySelector('[data-am-error="' + line + '"]');
    if (box) box.textContent = message;
    else if (message) window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
  }

  /* --- llamadas ---------------------------------------------------------- */

  function send(url, body, line, isForm) {
    var list = targets();
    var ids = list.map(function (t) { return t.id; }).join(',');

    var init = { method: 'POST', headers: { Accept: 'application/json' } };
    if (isForm) {
      body.append('sections', ids);
      body.append('sections_url', window.location.pathname);
      init.body = body;
    } else {
      body.sections = ids;
      body.sections_url = window.location.pathname;
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(body);
    }

    busy(true);
    return fetch(url, init)
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status || state.message) {
          // Shopify manda `description` cuando no alcanza el inventario.
          fail(line, state.description || state.message || '');
          return false;
        }
        fail(line, '');
        paint(state, list);
      })
      .catch(function () {
        // Si la red falla, que al menos el carrito real se vea: recarga.
        window.location.reload();
      })
      .finally(function () { busy(false); });
  }

  function setQuantity(line, quantity) {
    return send(base() + 'cart/change.js', { line: Number(line), quantity: Number(quantity) }, line, false);
  }

  /* Cambiar los sueltos por el paquete que los contiene.

     Va en una sola llamada a /cart/update.js: quita las líneas y mete el
     paquete a la vez. Hacerlo en dos pasos dejaría un instante con todo
     duplicado, y si el segundo fallara el cliente se quedaría pagando dos
     veces lo mismo. */
  function swapToPack(boton) {
    var pack = boton.getAttribute('data-pack');
    var drop = (boton.getAttribute('data-drop') || '').split(',').filter(Boolean);
    if (!pack || !drop.length) return;

    var updates = {};
    drop.forEach(function (id) { updates[id] = 0; });
    updates[pack] = 1;

    trabajando(boton, true);
    return send(base() + 'cart/update.js', { updates: updates }, null, false)
      .finally(function () { trabajando(boton, false); });
  }

  // El botón es su propia confirmación: aparece donde ya está el ojo y no
  // interrumpe nada. Se funde, aguanta 1.4 s y vuelve. Sin rebote.
  function confirmar(boton) {
    if (!boton || boton.dataset.amBusy === '1') return;
    boton.dataset.amBusy = '1';

    var etiqueta = boton.querySelector('[data-am-label]');
    if (!etiqueta) {
      etiqueta = document.createElement('span');
      etiqueta.setAttribute('data-am-label', '');
      etiqueta.textContent = boton.textContent.trim();
      boton.textContent = '';
      boton.appendChild(etiqueta);
    }
    var original = etiqueta.innerHTML;

    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fundido = reducido ? 0 : 160;

    var poner = function (html) { etiqueta.innerHTML = html; };
    var palomita = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"></path></svg>';
    /* Los botones redondos de alta rápida solo tienen sitio para el icono:
       meterles «Añadido» los reventaría. Se confirman con la palomita sola. */
    var listo = boton.hasAttribute('data-am-icon')
      ? palomita
      : palomita.replace('aria-hidden="true"', 'aria-hidden="true" style="vertical-align:-2px;margin-right:7px"') + 'Añadido';

    boton.classList.add('is-swapping');
    setTimeout(function () { poner(listo); boton.classList.remove('is-swapping'); }, fundido);
    setTimeout(function () { boton.classList.add('is-swapping'); }, 1400);
    setTimeout(function () {
      poner(original);
      boton.classList.remove('is-swapping');
      boton.dataset.amBusy = '0';
    }, 1400 + fundido);
  }

  // Entre el clic y la respuesta pasa hasta un segundo. Sin señal, ese hueco
  // es exactamente lo que se siente tosco: se atenúa la etiqueta al instante
  // y la palomita llega cuando el servidor confirma.
  function trabajando(boton, si) {
    if (!boton) return;
    boton.classList.toggle('is-working', si);
    if (si) boton.setAttribute('aria-busy', 'true');
    else boton.removeAttribute('aria-busy');
  }

  function addForm(form, boton) {
    // FormData respeta radios marcados, selects y properties[]: leer los
    // inputs a mano se comía el plan de suscripción de la ficha.
    var data = new FormData(form);
    trabajando(boton, true);
    return send(base() + 'cart/add.js', data, null, true).then(function (ok) {
      trabajando(boton, false);
      if (ok === false) return;
      confirmar(boton);
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.open && !drawer.classList.contains('active')) drawer.open();
    });
  }

  /* --- eventos ----------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var qty = event.target.closest('[data-am-qty]');
    if (qty) {
      event.preventDefault();
      setQuantity(qty.getAttribute('data-line'), qty.getAttribute('data-value'));
      return;
    }

    var remove = event.target.closest('[data-am-remove]');
    if (remove) {
      event.preventDefault();
      setQuantity(remove.getAttribute('data-line'), 0);
      return;
    }

    var swap = event.target.closest('[data-am-swap]');
    if (swap) {
      event.preventDefault();
      swapToPack(swap);
      return;
    }

    var close = event.target.closest('[data-am-close]');
    if (close) {
      event.preventDefault();
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.close) drawer.close();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-am-add]');
    if (!form) return;
    event.preventDefault();
    addForm(form, event.submitter);
  });

})();
